import { create } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';
import { HYDRATING } from '../utils/hydrating';
import { safeLocalStorage } from '../utils/safeStorage';

export type ViewMode = 'client' | 'provider';

interface ViewModeState {
    mode: ViewMode;
    setMode: (mode: ViewMode) => void;
    toggleMode: () => void;
}

export const useViewModeStore = create<ViewModeState>()(
    persist(
        (set, get) => ({
            mode: 'client',
            setMode: (mode) => set({ mode }),
            toggleMode: () => set({ mode: get().mode === 'client' ? 'provider' : 'client' }),
        }),
        {
            name: 'bricolat-view-mode',
            // Without a usable storage, zustand would not attach `.persist` at all (see main.tsx).
            storage: createJSONStorage((): StateStorage<unknown> => safeLocalStorage),
            // Hydrating page: first render uses the default, stored mode is applied after hydration.
            skipHydration: HYDRATING,
        }
    )
);
